// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetEnrollmentStatusRequestModel {
    static getAttributeTypeMap() {
        return GetEnrollmentStatusRequestModel.attributeTypeMap;
    }
}
GetEnrollmentStatusRequestModel.discriminator = undefined;
GetEnrollmentStatusRequestModel.additionalProperties = false;
GetEnrollmentStatusRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "BasicEnrollmentGender"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
];
//# sourceMappingURL=getEnrollmentStatusRequestModel.js.map